<template>
  <div
    v-if="
      (meeting.meeting_status === 0 && meeting.meeting_type_id === 7) ||
      meeting.meeting_status === 1 ||
      meeting.meeting_status === 2 ||
      meeting.meeting_status === 5" class="talkCards">
      <el-row>
        <span class="tipMsg">温馨提示：今日工作重点，一个任务写一行，任务前面加编号，如1.</span>
      </el-row>
      <el-row>
        <el-col :span="4">参会人</el-col>
        <el-col :span="6">本周工作重点</el-col>
        <el-col :span="9">今日工作重点</el-col>
        <el-col :span="3">确认人</el-col>
      </el-row>
      <el-form>
        <el-card
          v-for="(item, index) in meeting.attendees"
          :key="index"
          shadow="never"
          style="margin-top: 5px">
          <el-row>
            <el-col :span="3">
              <div class="aaa">
                {{ item.name }}
                <i
                  class="el-icon-document"
                  style="cursor: pointer"
                  title="昨日回顾"
                  @click="forYesterday(item)"
                />
              </div>
            </el-col>

            <el-col :span="6">
              <div class="taskname">
                <el-form-item>
                  <div v-for="(domain, keys) in item.task" :key="keys">
                    <el-input
                      v-if="domain.task_type==='week' && domain.todayWeek"
                      v-model="domain.value"
                      :autosize="{minRows: 2}"
                      type="textarea" />
                      <!-- 写过的、周任务、并且不是召集人 主持人 秘书 显示 文字 -->
                    <div v-if="domain.task_type==='week' && domain.todayWeek === false" class="weekDiv" title="只读">
                          {{domain.value}}
                    </div>
                  </div>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="14">
              <el-row>
                <div
                  v-for="(domain, keys) in item.task"
                  :key="keys"
                  class="task">
                  <el-col :span="14">
                    <el-form-item>
                      <el-input
                        v-if="domain.task_type === 'day'"
                        v-model="domain.value"
                        :disabled="domain.isDisabled"
                        :autosize="{ minRows: 2 }"
                        width="90%"
                        type="textarea"
                        placeholder="请输入内容"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <div class="taskname">
                      <el-form-item>
                        <el-select
                          v-if="domain.task_type === 'day'"
                          v-model="domain.user.label"
                          :remote-method="remoteMethod6"
                          :loading="loading"
                          :disabled="domain.isDisabled"
                          filterable
                          remote
                          reserve-keyword
                          size="mini"
                          placeholder="请输入姓名"
                          @change="handleRemote6"
                        >
                          <el-option
                            v-for="item in useroptions6"
                            :key="item.value"
                            :label="item.label + '(' + item.value + ')'"
                            :value="item"
                          />
                        </el-select>
                      </el-form-item>
                    </div>
                  </el-col>
                  <!--以下都不是，取反，只要一个符合就true 当前登陆人可以更改自己的，主持人，召集人，秘书可以改所有的。借用上面那个disable取反 隐藏其他人的加减号，生成的数据空值过滤 -->
                  <el-col
                    v-show="
                      !(
                        item.workcode !== $store.getters.username &&
                        meeting.secretary.workcode !==
                          $store.getters.username &&
                        meeting.host.workcode &&
                        $store.getters.username &&
                        meeting.convenor.workcode !==
                          $store.getters.username
                      )
                    "
                    :span="3" style="display: flex;">
                    <i
                      v-show="domain.task_type ==='day' && !meeting.overTime "
                      class="el-icon-circle-plus add"
                      @click="submitAdd(index, keys, item.task)"
                    />
                    <i
                      v-show="domain.task_type ==='day' && ((domain.task_status === 0 && (meeting.secretary.workcode === $store.getters.username || meeting.host.workcode === $store.getters.username || meeting.convenor.workcode === $store.getters.username)|| domain.task_status === null))&& !meeting.overTime"
                      class="el-icon-remove cut"
                      @click="removeDomainChildren(index, domain)"
                    />
                    <!-- </div> -->
                  </el-col>
                </div>
              </el-row>
            </el-col>
          </el-row>
        </el-card>
      </el-form>
      <!-- 如果当前时间  大于结束时间的24.00 就不让提交 -->
      <el-button
        v-if="!meeting.overTime"
        :disabled="!subCan"
        size="small"
        type="primary"
        style="margin-top: 12px"
        @click="submit"
        >提交任务</el-button>
    <!-- 昨日任务 -->
    <el-dialog
      :title="DateFriday === '' ? yesterday + '任务执行情况' : DateFriday + ' 至 ' + yesterday + '任务执行情况'"
      :visible.sync="yesterdayShow"
      width="1200px">
      <el-table
        :data="yesterdayData"
        :header-cell-style="{
          background: '#409eff',
          padding: '8px 0',
          color: '#fff',
        }"
        :span-method="spanMethod"
        height="400px"
        border
        size="mini">
        <el-table-column label="姓名" prop="name" width="90" />
        <el-table-column label="工号" prop="workcode" width="90" />
        <el-table-column v-if="DateFriday!==''" label="日期" prop="meeting_time" width="120"/>
        <el-table-column
          :show-overflow-tooltip="true"
          label="会议主题"
          prop="meeting_subject">
          <template slot-scope="scope">
            <span>【{{ scope.row.meeting_id }}】</span>
            <span>{{ scope.row.meeting_subject }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          label="任务详情"
          prop="task_name"/>
        <el-table-column label="执行状态" prop="task_status" width="100">
          <template slot-scope="scope">
            <span
              v-if="scope.row.is_complete === 1 && scope.row.is_overdue === 1"
              class="grayColor">逾期完成</span>
            <span
              v-if="scope.row.is_complete === 0 && scope.row.is_overdue === 1"
              class="greenColor">逾期未完成</span>
            <span
              v-if="scope.row.is_complete === 1 && scope.row.is_overdue === 0"
              class="successColor">完成</span>
            <span
              v-if="scope.row.is_complete === 0 && scope.row.is_overdue === 0"
              class="yellowColor">未完成</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          label="执行情况"
          prop="progress"
        />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { getDetails } from '@/api/static'
import { addtask } from '@/api/morningMeeting'
import { deepClone } from '@/utils/index'

export default {
  props: {
    meeting: {
      type: Object,
      default: function() {
        return {}
      }
    },
    list: {
      type: Array,
      default: function() {
        return []
      }
    },
    yesterday: {
      type: String,
      default: function() {
        return ''
      }
    },
    DateFriday: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  data() {
    return {
      loading: false,
      useroptions6: [],
      subCan: true,
      yesterdayShow: false,
      yesterdayData: []
    }
  },
  methods: {
    removeDomainChildren(key, item) {
      this.$emit('removeDomain', key, item)
    },
    submitAdd(index, keys, taskItem) {
      const attendees = JSON.parse(JSON.stringify(this.meeting.attendees))
      attendees[index].task.push({
        value: '',
        user: {
          value: attendees[index].workcode,
          label: attendees[index].name
        },
        taskRadio: 'day',
        task_type: 'day',
        isNew: true
      })
      this.$set(this.meeting, 'attendees', attendees)
    },
    submit() {
      // 当天24点之后不能提交
      let can = true
      // 已预约的早晚会提交任务，需开会前一天晚8点之后。
      if (this.meeting.meeting_status === 0 && this.meeting.meeting_type_id === 7) {
        const isNow = new Date()
        const startTime =
          this.meeting.estimate_start_time.split(' ')[0] + ' 00:00:00'
        const toDay = new Date(startTime)
        const prvDay = new Date(toDay.getTime() - 24 * 60 * 60 * 1000)
        const Y = prvDay.getFullYear()
        const MM = prvDay.getMonth() + 1
        const M = MM < 10 ? '0' + MM : MM
        const D =
          prvDay.getDate() < 10 ? '0' + prvDay.getDate() : prvDay.getDate()
        const needTime = Y + '-' + M + '-' + D + ' 17:00:00'
        const needDate = new Date(needTime)
        console.log(needDate.getTime())
        console.log(isNow.getTime())

        if (isNow.getTime() < needDate.getTime()) {
          can = false
          this.$message.warning(
            '“已预约”状态会议提交任务的时间只能在开会前一天晚上17:00之后才可以开始填写'
          )
        }
      }
      if (!can) {
        return
      }
      // 任务截止日期为，预约会议的结束日期，的晚7点
      const latestDay = this.meeting.estimate_end_time.split(' ')[0]
      const newAdd = {
        meeting_id: this.$route.query.id,
        start_time: `${latestDay} 00:00:00`,
        end_time: `${latestDay} 19:00:00`,
        data: []
      }
      const oldEdit = JSON.parse(JSON.stringify(newAdd))
      for (let i = 0; i < this.meeting.attendees.length; i++) {
        const params = {}
        params.executor = {
          name: this.meeting.attendees[i].name,
          workcode: this.meeting.attendees[i].workcode
        }
        params.day = []
        // 修改数据
        const paramsEdit = JSON.parse(JSON.stringify(params))

        for (let j = 0; j < this.meeting.attendees[i].task.length; j++) {
          // 如果用户没有输入东西，过滤掉这条。用户只能提交自己的任务，三个角色可以提交所有的任务
          const taskData = this.meeting.attendees[i].task[j]
          if (
            taskData.value === '' ||
            (taskData.task_type === 'day' && !taskData.user.label) ||
            (this.meeting.attendees[i].workcode !==
              this.$store.getters.username &&
              this.meeting.secretary.workcode !==
                this.$store.getters.username &&
              this.meeting.host.workcode &&
              this.$store.getters.username &&
              this.meeting.convenor.workcode !== this.$store.getters.username)
          ) {
            continue
          }
          if (taskData.isNew) {
            if (taskData.task_type === 'week') {
              params.week = taskData.value
              params.addWeek = 'yes'
            } else if (taskData.task_type === 'day') {
              const json = {
                task_name: taskData.value,
                task_desc: taskData.value
              }
              json.confirm = typeof taskData.user.label === 'object'
                ? { name: taskData.user.label.label, workcode: taskData.user.label.value }
                : { name: taskData.user.label, workcode: taskData.user.value }

              params.day.push(json)
            }
          } else {
            if (taskData.task_type === 'week') {
              paramsEdit.week = taskData.value
              paramsEdit.week_id = taskData.id
              paramsEdit.addWeek = 'yes'
            } else if (taskData.task_type === 'day') {
              const json = {
                task_name: taskData.value,
                task_desc: taskData.value,
                task_id: taskData.task_id
              }
              json.confirm = typeof taskData.user.label === 'object'
                ? { name: taskData.user.label.label, workcode: taskData.user.label.value }
                : { name: taskData.user.label, workcode: taskData.user.value }
              paramsEdit.day.push(json)
            }
          }
        }
        console.log(params)
        if (
          JSON.stringify(params) !== '{}' &&
          (params.day.length > 0 ||
            (params.day.length === 0 && params.addWeek === 'yes'))
        ) {
          newAdd.data.push(params)
        }
        if (
          JSON.stringify(paramsEdit) !== '{}' &&
          (paramsEdit.day.length > 0 ||
            (paramsEdit.day.length === 0 && paramsEdit.addWeek === 'yes'))
        ) {
          oldEdit.data.push(paramsEdit)
        }
      }
      console.log(newAdd)
      console.log(oldEdit)
      this.subCan = false
      if (!(
        this.meeting.secretary.workcode !== this.$store.getters.username &&
        this.meeting.host.workcode !== this.$store.getters.username &&
        this.meeting.convenor.workcode !== this.$store.getters.usernam
      )) {
        newAdd.data = newAdd.data.concat(oldEdit.data)
      }
      if (newAdd.data.length > 0) {
        addtask(newAdd)
          .then((res) => {
            if (res.code === 'success') {
              this.$message.success('操作成功')
              setTimeout(() => {
                window.location.reload()
              }, 1500)
            } else {
              this.$message.error(res.data.task.error.join(','))
              setTimeout(() => {
                window.location.reload()
              }, 1500)
            }
          })
          .catch((err) => {
            this.$message({
              type: 'error',
              message: err.message
            })
            this.subCan = true
          })
      } else {
        this.$message.warning('您没有提交任何数据')
        this.subCan = true
      }
    },
    remoteMethod6(query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.useroptions6 = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.useroptions6 = []
      }
      console.log('val', this.meeting.attendees)
    },
    handleRemote6(e) {
      const attendees = deepClone(this.meeting.attendees)
      this.$set(this.meeting, 'attendees', attendees)
    },
    forYesterday(item) {
      this.yesterdayShow = true
      const params = {
        workcode: item.workcode,
        start_time: this.DateFriday
          ? this.DateFriday + ' 00:00:00'
          : this.yesterday + ' 00:00:00', // 会议创建 开始时间 如：2019-01-04 00:00:00
        end_time: this.yesterday + ' 23:59:59' //	会议创建 结束时间 如 2019-01-05 00:00:00
      }
      this.yesterdayData = []
      const array = []
      getDetails(params).then((res) => {
        console.log(res)
        if (res.code === 'success' && res.data.morningNight.length > 0) {
          const allTask = res.data.morningNight
          allTask.forEach((element) => {
            element.tasks.forEach((item, index) => {
              item.num = index === 0 ? element.tasks.length : 0
              item.meeting_id = element.meeting_id
              item.meeting_subject = element.meeting_subject
              item.meeting_time = element.meeting_time
              if (item.task_status <= 3) {
                array.push(item)
              }
            })
          })
          console.log(array)
          this.yesterdayData = array
          // this.$forceUpdate();
        } else {
          this.yesterdayData = []
        }
      })
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 3) {
        if (row.num) {
          return {
            rowspan: row.num,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.talkCards {
  margin-top: 5px;
  font-size: 14px;
  height: auto;

  .prson {
    height: auto;
    line-height: -50%;
  }

  .task {
    height: auto;

    .taskname {
      margin: 0 5px;
    }
  }

  .add {
    display: inline-block;
    font-size: 32px;
    // position: absolute;
    margin-top: 4px;
    bottom: 18px;
    color: #606266;
  }

  .cut {
    display: inline-block;
    font-size: 32px;
    // position: absolute;
    color: #606266;
    // margin-left: 40px;
    margin-top: 4px;
  }
}
.weekDiv {
  width: 100%;
  border: 1px solid #e4e7ed;
  border-radius: 3px;
  word-break: break-all;
  padding: 5px 15px;
  line-height: 1.5;
  min-height: 54px;
  background-color: #f5f7fa;
  white-space: pre-line;
  color: #606266;
}

</style>
